import { render } from "./Balanta.vue?vue&type=template&id=730a8118&scoped=true&ts=true"
import script from "./Balanta.ts?vue&type=script&lang=ts"
export * from "./Balanta.ts?vue&type=script&lang=ts"

import "./Balanta.vue?vue&type=style&index=0&id=730a8118&scoped=true&lang=scss"

import exportComponent from "D:\\OdocsPortal\\odocsportal-frontend-master\\odocsportal-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-730a8118"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QBtn,QTable,QCard,QList,QItem,QItemSection,QItemLabel});
